import type { ActivityVia } from './activity.model'

export type { ActivityVia }

/** How an action was reached. `key` is present exactly when `via` is `'key'`. */
export interface ActivityTrigger {
  readonly via: ActivityVia
  readonly key?: string
}

const make = (via: ActivityVia): ActivityTrigger => Object.freeze({ via })

/** Constant triggers; `via: 'key'` triggers come from the ambient key frame. */
export const VIA = Object.freeze({
  click: make('click'),
  menu: make('menu'),
  map: make('map'),
  list: make('list'),
  auto: make('auto'),
})
